import {css} from "@panda/css";

import {Range, RangeColorVariant} from "@pg-design/range-module";
import {useFormContextRHF} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";
import {KM_PREFERENCES_FORM_TEST_IDS} from "@pg-mono/test-ids";

import {RoomSelector} from "@/components/room_selector/RoomSelector";

import {
    HOME_MATCH_PREFERENCES_SURVEY_AREA_MAX,
    HOME_MATCH_PREFERENCES_SURVEY_AREA_MIN,
    HOME_MATCH_PREFERENCES_SURVEY_CONTENT
} from "../../../constants/preferences/home_match_preferences_survey_content";
import {IHomeMatchPreferencesSurveyForm} from "../../../types/home_match_preferences";
import {getHomeMatchAreaAfterSliderChange} from "../../../utils/get_home_match_area_after_slider_change";
import {HomeMatchPreferencesSurveyAreaInput} from "./HomeMatchPreferencesSurveyAreaInput";

const {AREA, AREA_FROM, AREA_RANGE_SEPARATOR, AREA_TO, ROOMS} = HOME_MATCH_PREFERENCES_SURVEY_CONTENT;

const clampAreaBound = (value: number | undefined, fallback: number) => {
    if (value == null || !Number.isFinite(value)) return fallback;

    return Math.min(Math.max(value, HOME_MATCH_PREFERENCES_SURVEY_AREA_MIN), HOME_MATCH_PREFERENCES_SURVEY_AREA_MAX);
};

export const HomeMatchPreferencesSurveySizeFields = () => {
    const {setValue, watch} = useFormContextRHF<IHomeMatchPreferencesSurveyForm>();
    const area = watch("area");
    // The slider only gets finite, ordered bounds inside its range: a value outside it (typed, but not yet snapped back on blur) makes it drop a thumb.
    const lowerBound = clampAreaBound(area?.lower, HOME_MATCH_PREFERENCES_SURVEY_AREA_MIN);
    const upperBound = clampAreaBound(area?.upper, HOME_MATCH_PREFERENCES_SURVEY_AREA_MAX);
    const areaLower = Math.min(lowerBound, upperBound);
    const areaUpper = Math.max(lowerBound, upperBound);

    return (
        <>
            <div className={roomsFieldStyle}>
                <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                    {ROOMS}
                </Text>
                <RoomSelector dataTestId={KM_PREFERENCES_FORM_TEST_IDS.ROOMS_SELECTOR} name="rooms" />
            </div>

            <div className={fieldStyle}>
                <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                    {AREA}
                </Text>
                <div className={areaRowStyle}>
                    <div className={areaRangeStyle}>
                        <Range
                            colorVariant={RangeColorVariant.LAVENDER}
                            hideLabels
                            max={HOME_MATCH_PREFERENCES_SURVEY_AREA_MAX}
                            min={HOME_MATCH_PREFERENCES_SURVEY_AREA_MIN}
                            name="area"
                            onChange={(_name, value) => {
                                const nextArea = getHomeMatchAreaAfterSliderChange(area, {lower: areaLower, upper: areaUpper}, value);

                                if (nextArea) setValue("area", nextArea, {shouldDirty: true});
                            }}
                            step={1}
                            useDynamicChange
                            value={{lower: areaLower, upper: areaUpper}}
                        />
                    </div>
                    <div className={areaInputsStyle}>
                        <HomeMatchPreferencesSurveyAreaInput
                            ariaLabel={AREA_FROM}
                            max={HOME_MATCH_PREFERENCES_SURVEY_AREA_MAX}
                            min={HOME_MATCH_PREFERENCES_SURVEY_AREA_MIN}
                            onChange={(value) => setValue("area.lower", value, {shouldDirty: true})}
                            placeholder={AREA_FROM}
                            value={area?.lower}
                        />
                        <Text as="span" preserveFontSize variant="body_copy_2">
                            {AREA_RANGE_SEPARATOR}
                        </Text>
                        <HomeMatchPreferencesSurveyAreaInput
                            ariaLabel={AREA_TO}
                            max={HOME_MATCH_PREFERENCES_SURVEY_AREA_MAX}
                            min={HOME_MATCH_PREFERENCES_SURVEY_AREA_MIN}
                            onChange={(value) => setValue("area.upper", value, {shouldDirty: true})}
                            placeholder={AREA_TO}
                            value={area?.upper}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

const fieldStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2
});

const roomsFieldStyle = css({
    "--select-active-color": "var(--colors-secondary)",
    "--select-active-text-color": "var(--colors-white)",
    display: "flex",
    flexDirection: "column",
    gap: 2
});

const areaRowStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2.5,

    md: {
        alignItems: "center",
        flexDirection: "row",
        gap: 3
    }
});

const areaInputsStyle = css({
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",

    md: {
        flex: "0 0 auto",
        gap: 2,
        justifyContent: "flex-start"
    }
});

const areaRangeStyle = css({
    width: "100%",

    md: {
        flex: "1",
        minWidth: 0,
        width: "auto"
    }
});
import {css} from "@panda/css";

import {Range, RangeColorVariant} from "@pg-design/range-module";
import {useFormContextRHF} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";
import {KM_PREFERENCES_FORM_TEST_IDS} from "@pg-mono/test-ids";

import {RoomSelector} from "@/components/room_selector/RoomSelector";

import {
    HOME_MATCH_PREFERENCES_SURVEY_AREA_MAX,
    HOME_MATCH_PREFERENCES_SURVEY_AREA_MIN,
    HOME_MATCH_PREFERENCES_SURVEY_CONTENT
} from "../../../constants/preferences/home_match_preferences_survey_content";
import {IHomeMatchPreferencesSurveyForm} from "../../../types/home_match_preferences";
import {getHomeMatchAreaAfterSliderChange} from "../../../utils/get_home_match_area_after_slider_change";
import {HomeMatchPreferencesSurveyAreaInput} from "./HomeMatchPreferencesSurveyAreaInput";

const {AREA, AREA_FROM, AREA_RANGE_SEPARATOR, AREA_TO, ROOMS} = HOME_MATCH_PREFERENCES_SURVEY_CONTENT;

const clampAreaBound = (value: number | undefined, fallback: number) => {
    if (value == null || !Number.isFinite(value)) return fallback;

    return Math.min(Math.max(value, HOME_MATCH_PREFERENCES_SURVEY_AREA_MIN), HOME_MATCH_PREFERENCES_SURVEY_AREA_MAX);
};

export const HomeMatchPreferencesSurveySizeFields = () => {
    const {setValue, watch} = useFormContextRHF<IHomeMatchPreferencesSurveyForm>();
    const area = watch("area");
    // The slider only gets finite, ordered bounds inside its range: a value outside it (typed, but not yet snapped back on blur) makes it drop a thumb.
    const lowerBound = clampAreaBound(area?.lower, HOME_MATCH_PREFERENCES_SURVEY_AREA_MIN);
    const upperBound = clampAreaBound(area?.upper, HOME_MATCH_PREFERENCES_SURVEY_AREA_MAX);
    const areaLower = Math.min(lowerBound, upperBound);
    const areaUpper = Math.max(lowerBound, upperBound);

    return (
        <>
            <div className={roomsFieldStyle}>
                <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                    {ROOMS}
                </Text>
                <RoomSelector dataTestId={KM_PREFERENCES_FORM_TEST_IDS.ROOMS_SELECTOR} name="rooms" />
            </div>

            <div className={fieldStyle}>
                <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                    {AREA}
                </Text>
                <div className={areaRowStyle}>
                    <div className={areaRangeStyle}>
                        <Range
                            colorVariant={RangeColorVariant.LAVENDER}
                            hideLabels
                            max={HOME_MATCH_PREFERENCES_SURVEY_AREA_MAX}
                            min={HOME_MATCH_PREFERENCES_SURVEY_AREA_MIN}
                            name="area"
                            onChange={(_name, value) => {
                                const nextArea = getHomeMatchAreaAfterSliderChange(area, {lower: areaLower, upper: areaUpper}, value);

                                if (nextArea) setValue("area", nextArea, {shouldDirty: true});
                            }}
                            step={1}
                            useDynamicChange
                            value={{lower: areaLower, upper: areaUpper}}
                        />
                    </div>
                    <div className={areaInputsStyle}>
                        <HomeMatchPreferencesSurveyAreaInput
                            ariaLabel={AREA_FROM}
                            max={HOME_MATCH_PREFERENCES_SURVEY_AREA_MAX}
                            min={HOME_MATCH_PREFERENCES_SURVEY_AREA_MIN}
                            onChange={(value) => setValue("area.lower", value, {shouldDirty: true})}
                            placeholder={AREA_FROM}
                            value={area?.lower}
                        />
                        <Text as="span" preserveFontSize variant="body_copy_2">
                            {AREA_RANGE_SEPARATOR}
                        </Text>
                        <HomeMatchPreferencesSurveyAreaInput
                            ariaLabel={AREA_TO}
                            max={HOME_MATCH_PREFERENCES_SURVEY_AREA_MAX}
                            min={HOME_MATCH_PREFERENCES_SURVEY_AREA_MIN}
                            onChange={(value) => setValue("area.upper", value, {shouldDirty: true})}
                            placeholder={AREA_TO}
                            value={area?.upper}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

const fieldStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2
});

const roomsFieldStyle = css({
    "--select-active-color": "var(--colors-secondary)",
    "--select-active-text-color": "var(--colors-white)",
    display: "flex",
    flexDirection: "column",
    gap: 2
});

const areaRowStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2.5,

    md: {
        alignItems: "center",
        flexDirection: "row",
        gap: 3
    }
});

const areaInputsStyle = css({
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",

    md: {
        flex: "0 0 auto",
        gap: 2,
        justifyContent: "flex-start"
    }
});

const areaRangeStyle = css({
    width: "100%",

    md: {
        flex: "1",
        minWidth: 0,
        width: "auto"
    }
});
